<template>
  <v-card
    class="ma-2"
    dark
    elevation="20"
    :to="{ path: '/character/' + characterName }"
  >
    <v-card-title class="white--text pa-0 pl-2">
      {{ characterName }}
      <v-spacer></v-spacer>
      Lv.{{ level }}
      <v-icon class="white--text" size="0.9rem">icon-{{ bdoClass }}</v-icon>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "CharacterCard",
  props: { bdoClass: String, characterName: String, level: String }
};
</script>